import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchClients } from '../../store/slices/staffingSlice';
import Layout from '../../components/Layout';
import Loading from '../../components/Loading';
import Pagination from '../../components/Pagination';
import StatusCounts from '../../components/StatusCounts';
import { formatDateTime } from '../../utils/formatDate';
import { useNavigate } from 'react-router-dom';

const StaffingDashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { clients, pagination, loading } = useSelector((state) => state.staffing);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');

  useEffect(() => {
    dispatch(fetchClients({ page, search }));
  }, [dispatch, page, search]);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setPage(1);
  };

  return (
    <Layout>
      <div className="container-fluid">
        <div className="dashboard-header">
          <h1>Staffing Sales Dashboard</h1>
          <button
            className="btn btn-primary"
            onClick={() => navigate('/staffing/clients/new')}
          >
            <i className="ti ti-plus me-1" />
            Create Client
          </button>
        </div>

        {/* Search */}
        <div className="card mb-3">
          <div className="card-body">
            <div className="row g-3">
              <div className="col-sm-6 col-lg-4">
                <label className="form-label small mb-1">Search</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by client name, contact person, or email"
                  value={search}
                  onChange={handleSearchChange}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Clients Table */}
        <div className="card table-responsive">
          {loading ? (
            <Loading />
          ) : (
            <>
              <table className="table mb-0 text-nowrap table-hover">
                <thead className="table-light border-light">
                  <tr>
                    <th>Client Name</th>
                    <th>Contact Person</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Requirements</th>
                    <th>Candidates</th>
                    <th>Created</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {clients.length === 0 ? (
                    <tr>
                      <td colSpan={8} className="text-center py-4 text-muted">
                        No clients found
                      </td>
                    </tr>
                  ) : (
                    clients.map((client) => (
                      <tr key={client._id} className="align-middle">
                        <td className="fw-medium">{client.name}</td>
                        <td>{client.contact_person}</td>
                        <td>{client.email}</td>
                        <td>{client.phone}</td>
                        <td><StatusCounts stats={client.requirement_stats} emptyText="No requirements" /></td>
                        <td><StatusCounts stats={client.candidate_stats} emptyText="No candidates" /></td>
                        <td>{formatDateTime(client.created_at)}</td>
                        <td>
                          <button
                            className="btn btn-sm btn-outline-primary"
                            onClick={() => navigate(`/staffing/clients/${client._id}`)}
                          >
                            View
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
              <div className="p-3">
                <Pagination pagination={pagination} onPageChange={setPage} />
              </div>
            </>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default StaffingDashboard;
